/**
 * Символы раздела «Водоснабжение» для плана — по компоненту на элемент каталога.
 *
 * Вид сверху, как на планах водоснабжения: водорозетка — кружок вывода на грани стены,
 * стояк — труба в разрезе (кружок с точкой-осью), коллектор — гребёнка с отводами.
 * На развёртке (`facing="front"`) те же знаки: они мелкие и читаются одинаково.
 * Рисунок задан в собственном viewBox в миллиметрах объекта и растягивается
 * в габарит (UI.SymbolFrame). Цвет — через currentColor: холодная синяя, горячая красная.
 */
import { WaterId } from "@/shared/catalog";
import { UIKit, type SymbolComponent } from "@/shared/ui";

/** Водорозетка одной среды: кружок вывода с точкой оси */
export const OutletSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 60 60" {...props}>
		<circle cx="30" cy="30" r="22" fill="none" stroke="currentColor" strokeWidth="5" />
		<circle cx="30" cy="30" r="7" fill="currentColor" />
	</UIKit.SymbolFrame>
);

/** Парная водорозетка под смеситель: горячая слева (залита), холодная справа, между осями 150 мм */
export const PairOutletSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 210 60" {...props}>
		<line x1="52" y1="30" x2="158" y2="30" stroke="currentColor" strokeWidth="4" />
		<circle cx="30" cy="30" r="22" fill="none" stroke="currentColor" strokeWidth="5" />
		<circle cx="30" cy="30" r="12" fill="currentColor" />
		<circle cx="180" cy="30" r="22" fill="none" stroke="currentColor" strokeWidth="5" />
		<circle cx="180" cy="30" r="7" fill="currentColor" />
	</UIKit.SymbolFrame>
);

/** Стояк: труба в разрезе — двойной кружок с осью */
export const RiserSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 110 110" {...props}>
		<circle cx="55" cy="55" r="48" fill="none" stroke="currentColor" strokeWidth="7" />
		<circle cx="55" cy="55" r="30" fill="none" stroke="currentColor" strokeWidth="5" />
		<path d="M55 25v60M25 55h60" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
	</UIKit.SymbolFrame>
);

/** Коллектор: гребёнка с отводами вниз, к потребителям */
export const ManifoldSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 300 200" {...props}>
		<rect
			x="12"
			y="30"
			width="276"
			height="60"
			rx="30"
			fill="none"
			stroke="currentColor"
			strokeWidth="10"
		/>
		<path
			d="M60 90v80M120 90v80M180 90v80M240 90v80"
			stroke="currentColor"
			strokeWidth="10"
			strokeLinecap="round"
		/>
		<circle cx="60" cy="176" r="12" fill="currentColor" />
		<circle cx="120" cy="176" r="12" fill="currentColor" />
		<circle cx="180" cy="176" r="12" fill="currentColor" />
		<circle cx="240" cy="176" r="12" fill="currentColor" />
	</UIKit.SymbolFrame>
);

export const WATER_SYMBOLS: Record<WaterId, SymbolComponent> = {
	[WaterId.RiserCold]: RiserSymbol,
	[WaterId.RiserHot]: RiserSymbol,
	[WaterId.Manifold]: ManifoldSymbol,
	[WaterId.OutletCold]: OutletSymbol,
	[WaterId.OutletHot]: OutletSymbol,
	[WaterId.OutletPair]: PairOutletSymbol,
};
